<template>
    <input hidden ref="file" @change="onChange" type="file" :accept="$attrs.accept"
           v-bind:multiple="$attrs.multiple">

    <slot :props="{to_upload, uploading, errors}" :methods="{open,remove,reset}">
    </slot>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import filesManager from "../api/File";

@Options({
    name: 'FileUpload',
    components: {NextButton},
    inheritAttrs: false,
    props: {
        uploaded_files: {
            required: false,
            type: Array,
            default: () => []
        },
        to_delete: {
            required: false,
            type: Array,
            default: () => []
        },
        model_files: {
            required: false,
            type: Array,
            default: () => []
        },
    }
})
export default class FileUpload extends Vue {

    private to_upload: File[] = []
    private uploaded_files!: any[]
    private uploading = false
    private errors: any = {}

    send() {
        this.uploading = true
        const data = new FormData()

        this.to_upload.forEach((f) => {
            data.append('assets[]', f)
        })
        return filesManager.filesCreate(data).then((res) => {
            this.to_upload.splice(0)
            if (this.$attrs.mutable) {
                this.$emit('update:uploaded_files', [...this.uploaded_files, ...res.data])
            } else {
                this.$emit('update:uploaded_files', [...res.data])
            }
            this.errors = {}
            return res
        }).catch(res => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
                //se c'e un errore di validazione allora elimino il file che ha dato errore
                for (const key in this.errors) {
                    const index = Number(key.split('.')[1])
                    const file = this.to_upload[index]
                    //@ts-ignore
                    this.errors[key] = this.errors[key].map((err:string)=>{
                        return err.replace(key,`Il file ${file.name}`)
                    })
                }
            }
        }).finally(() => {
            this.uploading = false
        })
    }

    get IsMultiple(){
        return this.$attrs.multiple != undefined
    }

    onChange(ev: Event) {
        if (this.$attrs.readonly) return;
        const files = (ev.target as HTMLInputElement).files || (ev as DragEvent).dataTransfer?.files;
        if (!files?.length) return;

        if(this.IsMultiple){
            for (let i = 0; i < files.length; i++) {
                this.to_upload.push(files[i])
            }
        } else {
            this.to_upload.splice(0, this.to_upload.length, files[0])
        }

        this.send();
    }

    open() {
        if (this.$attrs.readonly) return;
        (this.$refs.file as HTMLBaseElement).click()
    }
    reset() {
        (this.$refs.file as HTMLInputElement).value = ''
        this.to_upload.splice(0)
        this.errors = {}
    }

    remove(list:any[], idx: number) {
        list.splice(idx, 1)
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
